import React from 'react'
import styled from 'styled-components'
import th from 'utils/themeHelper'

const ButtonBase = styled.button`
  outline: none;
  background: ${props =>
    props.disabled
      ? th('backgrounds.mid')
      : props.background
      ? props.background
      : props.secondary
      ? th('secondary.base')
      : th('primary.base')};
  border: none;
  border-radius: 3px;
  color: ${props => (props.disabled ? th('text.dark') : props.color || 'white')};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  display: block;
  font-family: ${th('fonts.bold')};
  font-size: 15px;
  padding: ${th('spacing.small', 'px')} ${th('spacing.default', 'px')};
  width: ${props => (props.wide ? '100%' : 'auto')};

  @media screen and (max-width: 769px) {
    max-width: ${props => (props.wide ? '100%' : 'max-content')};
  }

  &:hover {
    box-shadow: inset 0 -4px 0 0 rgba(0, 0, 0, 0.2);
  }

  &:focus {
    background: ${props => (props.disabled ? th('backgrounds.mid') : th('secondary.dark'))};
    box-shadow: none;
  }
`

const LinkButtonBase = styled.a`
  background: ${props =>
    props.disabled
      ? th('backgrounds.mid')
      : props.secondary
      ? th('primary.base')
      : th('secondary.base')};
  border: none;
  border-radius: 3px;
  color: ${props => (props.disabled ? th('text.dark') : 'white')};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  display: block;
  font-family: ${th('fonts.bold')};
  font-size: 15px;
  outline: none;
  padding: ${th('spacing.small', 'px')} ${th('spacing.default', 'px')};
  width: ${props => (props.wide ? '100%' : 'auto')};

  &:hover {
    box-shadow: inset 0 -4px 0 0 rgba(0, 0, 0, 0.2);
  }

  &:focus {
    background: ${props => (props.disabled ? th('backgrounds.mid') : th('secondary.dark'))};
    box-shadow: none;
  }
`

const LargeButton = ({ children, ...props }) => {
  if (props.href) {
    return <LinkButtonBase {...props}>{children}</LinkButtonBase>
  }

  return <ButtonBase {...props}>{children}</ButtonBase>
}

export default LargeButton
